import { AnnotationPlugin } from '@st/document-viewer-kit'
import { RectangleAnnotationElement, RectangleToolOverlay } from './ui'
import { RectToolState } from '~/st-doc-viewer/annotations'
import { RectangleAnnotation } from '@st/sdk'
import { copyToolState, RECT_COLOR_OPTIONS } from './tool-state'

export { RectangleToolEditor } from './ui'

const INITIAL_TOOL_STATE: RectToolState = {
  name: 'rectangle',
  settings: { border: { width: 3, color: RECT_COLOR_OPTIONS[0] } }
}

export function rectToolPlugin(): AnnotationPlugin<RectangleAnnotation, RectToolState> {
  return {
    name: 'rectangle',
    initialToolState: INITIAL_TOOL_STATE,
    ToolOverlay: RectangleToolOverlay,
    Element: RectangleAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'rectangle',
    onAnnotationSelected: (event) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        return { type: 'updateTool', tool: copyToolState(annotation) }
      }
      return null
    },
    onAnnotationDeselected: (event) => {
      if (event.annotationDraft)
        return { type: 'commitAnnotationDraft', annotationDraft: event.annotationDraft }
      return null
    }
  }
}
